import { useMemo } from "react";
import { CONTACT_TYPES } from "@miplatform/constants";

const filterContactsByLevel = (contacts = []) => {
  const relationships = new Set(
    contacts.map(({ level, label }) => `${label}-${level}`)
  );

  return contacts.filter(({ level, label }) => {
    return !(
      level === CONTACT_TYPES.COMMUNITIES &&
      relationships.has(`${label}-${CONTACT_TYPES.HOMES}`)
    );
  });
};

export const useContactGroups = (contacts = [], filteredData = []) => {
  const { currentHierarchyContacts, currentHierarchyFilteredData } = useMemo(
    () => ({
      currentHierarchyContacts: filterContactsByLevel(contacts),
      currentHierarchyFilteredData: filterContactsByLevel(filteredData),
    }),
    [contacts, filteredData]
  );

  const formattedItems = useMemo(() => {
    if (
      !Array.isArray(currentHierarchyContacts) ||
      !currentHierarchyContacts.length
    )
      return [];

    const grouped = Object.groupBy(
      currentHierarchyContacts,
      (contact) => contact.accountName
    );

    return Object.entries(grouped)
      .map(([name]) => ({ id: name, name }))
      .sort((a, b) => a.name.localeCompare(b.name));
  }, [currentHierarchyContacts]);

  const groupedContacts = useMemo(() => {
    if (
      !Array.isArray(currentHierarchyFilteredData) ||
      !currentHierarchyFilteredData.length
    )
      return [];
    if (!Array.isArray(formattedItems) || !formattedItems.length) return [];

    return formattedItems
      .map(({ name }) => {
        const contacts = currentHierarchyFilteredData.filter(
          (contact) => contact.accountName === name
        );

        return contacts.length ? [name, contacts] : null;
      })
      .filter(Boolean);
  }, [currentHierarchyFilteredData]);

  const groupedContactsByLevel = useMemo(() => {
    return Object.groupBy(filteredData, (contact) => contact.level);
  }, [filteredData]);

  return { formattedItems, groupedContacts, groupedContactsByLevel };
};
